// Implements: F-MCK-014, F-MCK-021
/**
 * The actions of a mockup's menus the caller may take: "Renombrar", "Compartir", "Transferir
 * propiedad", "Mover a otro ámbito" and "Mover a la papelera". The server answers each one from
 * its own write (`permissions.py` and, for the transfer, the personal scope's `409`); `owner_id`
 * does not say it, since org and platform admins act as owner and an assignment may grant a role.
 * So both menus, the gallery card's and the editor's "Más acciones", read the server's answers
 * through this one rule, and an answer without them offers none (audit P4, Q3 2026-10-19).
 */

import type { MockupSummary } from "../../../types/api";

/** The actions a menu may offer. */
export interface AllowedActions {
  readonly rename: boolean;
  readonly share: boolean;
  readonly transfer: boolean;
  readonly move: boolean;
  readonly trash: boolean;
}

export function allowedActionsOf(
  mockup: Pick<MockupSummary, "may_rename" | "may_share" | "may_transfer" | "may_change_scope" | "may_trash">,
): AllowedActions {
  return {
    rename: mockup.may_rename === true,
    share: mockup.may_share === true,
    transfer: mockup.may_transfer === true,
    move: mockup.may_change_scope === true,
    trash: mockup.may_trash === true,
  };
}
